import type { IAlertVariantsData } from "@components/molecules/alert";
import { Icon } from "@components/atoms/icons";

/**
 * Variants data for different alert types, including icons.
 * @type {IAlertVariantsData}
 */
export const VAlertVariants: IAlertVariantsData = {
  information: {
    /**
     * Icon for information alerts.
     * @type {ReactNode}
     */
    icon: (
      <Icon name={"InfoSquare"} type={"bold-duotone"} color={"primary-dark"} />
    ),
  },
  action: {
    /**
     * Icon for action alerts.
     * @type {ReactNode}
     */
    icon: (
      <Icon name={"Settings"} type={"bold-duotone"} color={"primary-dark"} />
    ),
  },
  delete: {
    /**
     * Icon for delete alerts.
     * @type {ReactNode}
     */
    icon: (
      <Icon
        name={"TrashBinTrash"}
        type={"bold-duotone"}
        color={"primary-dark"}
      />
    ),
  },
};
